import { useMemo } from 'react';
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  Radar,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { PILLARS } from '../lib/pillars';

const PROFILE_COLORS = [
  'hsl(var(--primary))',
  'hsl(var(--gold))',
  'hsl(var(--teal))',
  'hsl(var(--lavender))'
];

export const ExperienceMapComparison = ({ profiles }) => {
  const data = useMemo(() => {
    return PILLARS.map(pillar => {
      const row = { pillar: pillar.shortName };
      profiles.forEach((profile, i) => {
        row[`p${i}`] = profile.drivers?.[pillar.id]?.importance || 0;
      });
      return row;
    });
  }, [profiles]);

  if (profiles.length < 2) return null;

  return (
    <Card className="border-border bg-card" data-testid="experience-map-comparison">
      <CardHeader>
        <CardTitle className="text-xl font-light">Experience Map Comparison</CardTitle>
        <p className="text-xs text-muted-foreground mt-1">
          What matters most, overlaid across contexts
        </p>
      </CardHeader>
      <CardContent>
        <div className="w-full" style={{ height: 360 }}>
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart data={data} cx="50%" cy="50%" outerRadius="75%">
              <PolarGrid
                stroke="hsl(var(--border))"
                strokeOpacity={0.5}
              />
              <PolarAngleAxis
                dataKey="pillar"
                tick={{ fill: 'hsl(var(--foreground))', fontSize: 12, fontWeight: 300 }}
              />
              {profiles.map((profile, i) => (
                <Radar
                  key={profile.id}
                  name={profile.label}
                  dataKey={`p${i}`}
                  stroke={PROFILE_COLORS[i % PROFILE_COLORS.length]}
                  strokeWidth={2}
                  fill={PROFILE_COLORS[i % PROFILE_COLORS.length]}
                  fillOpacity={0.08 + (i === 0 ? 0.07 : 0)}
                />
              ))}
              <Legend
                wrapperStyle={{ fontSize: 12, fontWeight: 300 }}
              />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
